import $ from 'jquery'

class KnowledgeFilter {
    constructor() {

        this.filterItems = $('.knowledge-filter__input');
        this.knowledgePosts = $('.knowledge-post');

        this.events();
    }

    // Events
    events() {
        this.filterItems.on('click', this.filtersItemHandler.bind(this))
    }

    // Methods
    filtersItemHandler(e) {
        let checkedCats = [];
        this.filterItems.filter((id, item) => {
            if (item.checked) {
                checkedCats.push(item.getAttribute('name'))
            }
        });

        this.knowledgePosts.filter((id, post) => {
            if (checkedCats.includes(post.getAttribute('data-knowledge-cat'))) {
                post.style.display = 'block';
            } else {
                post.style.display = 'none';
            }
        })

    }

}

export default KnowledgeFilter;
